export default __webpack_public_path__ + "static/media/favicon.e6787c0a.ico";